import React, { PureComponent } from 'react';
import { Picker } from 'emoji-mart'

import Popout from './popout';

import 'emoji-mart/css/emoji-mart.css'

export default class EmojiPicker extends PureComponent {
    handleToggleClick = () => {
        this.popoutCtrl && this.popoutCtrl.show();
    }

    handleSelect = emoji => {
        this.props.onSelect && this.props.onSelect(emoji)

        this.hide();
    }

    hide() {
        this.popoutCtrl && this.popoutCtrl.hide();
    }

    render() {
        const childrenWithProps = React.Children.map(this.props.children, child => {
            return React.cloneElement(child, {
                onClick: this.handleToggleClick
            });
        });

        return (
            <React.Fragment>
                { childrenWithProps }

                <Popout className="auto-size emoji-picker-popout" defaultYPosition="top" provideController={ctrl => this.popoutCtrl = ctrl}>
                    <Picker onSelect={this.handleSelect} />
                </Popout>
            </React.Fragment>
        )
    }
}
